import React from 'react';
import { Col, Row } from 'reactstrap';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import {
  SelectInput,
  createDataWithOffices,
} from '../../containers/componentsInjection';

export const DashboardTopMessage = ({
  loading,
  message,
  offices,
  subtitle,
  filterOffice,
  setFilterOffice,
}) => {
  const DashboardTopMessageSkeleton = () => {
    return (
      <React.Fragment>
        <Row className="mb-3 pb-1">
          <Col xs={12} md={12} lg={12} className="mb-3">
            <div className="d-flex align-items-lg-start flex-lg-row flex-column">
              <div className="flex-grow-1">
                <SkeletonTheme baseColor="#8B919F">
                  <Skeleton height={30} width={150} />
                  <Skeleton height={20} width={100} />
                </SkeletonTheme>
              </div>
              <Col xs={12} md={2} lg={2}>
                <SkeletonTheme baseColor="#8B919F">
                  <Skeleton height={30} />
                </SkeletonTheme>
              </Col>
            </div>
          </Col>
        </Row>
      </React.Fragment>
    );
  };

  return loading ? (
    <DashboardTopMessageSkeleton />
  ) : (
    <React.Fragment>
      <Row className="mb-3 pb-1">
        <Col xs={12} md={12} lg={12} className="mb-3">
          <div className="d-flex align-items-lg-center flex-lg-row flex-column">
            <div className="flex-grow-1">
              <h4 className="fs-16 mb-1">{message}</h4>
              <p className="text-muted mb-0">{subtitle}</p>
            </div>
            <Col xs={12} md={2} lg={2}>
              <SelectInput
                isClearable
                className="form-control"
                inputId="organizationInput"
                value={filterOffice}
                onChange={(eventInput) => {
                  if (eventInput) {
                    setFilterOffice(eventInput);
                  } else {
                    setFilterOffice({
                      value: '',
                      label: 'Todos os escritórios',
                    });
                  }
                }}
                placeholder="Todos os escritórios"
                options={createDataWithOffices(offices || [])}
              />
            </Col>
          </div>
        </Col>
      </Row>
    </React.Fragment>
  );
};
